import { render, staticRenderFns } from "./safe-box.vue?vue&type=template&id=0164874d&scoped=true"
import script from "./safe-box.vue?vue&type=script&lang=js"
export * from "./safe-box.vue?vue&type=script&lang=js"
import style0 from "./safe-box.vue?vue&type=style&index=0&id=0164874d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0164874d",
  null
  
)

export default component.exports